export function getNewPortalBaseUrl() {
  const baseUrl = process.env.REACT_APP_NEW_PORTAL_URL
  if (!baseUrl) return null

  const normalized = baseUrl.replace(/\/$/, '')

  if (typeof window !== 'undefined' && normalized === window.location.origin) {
    console.error(
      '[portal-migration] REACT_APP_NEW_PORTAL_URL aponta para o portal legado. ' + 'Em local, use o host do portal novo (ex.: http://localhost:3000).',
    )
    return null
  }

  return normalized
}
